import { render, staticRenderFns } from "./Privacy-notice.vue?vue&type=template&id=f73e0546&scoped=true&"
import script from "./Privacy-notice.vue?vue&type=script&lang=js&"
export * from "./Privacy-notice.vue?vue&type=script&lang=js&"
import style0 from "./Privacy-notice.vue?vue&type=style&index=0&id=f73e0546&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f73e0546",
  null
  
)

export default component.exports